import { Route, Switch } from 'react-router';
import CreateRate from './create';
import EditRate from './edit';
import ApproveRates from './approve';

const Rates = () => {
  return (
    <Switch>
      <Route
        exact
        path='/admin/districts/:districtId/rates/new/'
        component={CreateRate}
      />
      <Route exact path='/admin/districts/:districtId/rates/approve' component={ApproveRates} />
      <Route
        exact
        path='/admin/districts/:districtId/rates/:id'
        component={EditRate}
      />
    </Switch>
  );
};

export default Rates;
